import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import classNames from "classnames";
import * as userSettingsActions from "../../actions/userSettings";

import styles from "./UserSettings.css";

class ChangePassword extends Component {
  constructor() {
    super();

    this.state = {
      password: "",
      password1: "",
      password2: "",
    };

    this.changePassword = this.changePassword.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  changePassword() {
    this
      .props
      .userSettingsActions
      .changePassword(this.state)
      .then(() => {
        this.props.toggleChangePassword();
      });
  }

  render() {
    return (
      <div className={styles.grayOverlay}>
        <div className={classNames(styles.createNewPasswordBox)}>
          <h2>Create a new password</h2>

          <div className={styles.inputLabels}>
            Current password
          </div>
          <div>
            <input onChange={this.handleChange} name="password" className={styles.changePasswordInputs} type="password" placeholder="Type your current password" aria-label="Current Password" />
          </div>

          <div className={styles.inputLabels}>
            New password
          </div>
          <div>
            <input onChange={this.handleChange} name="password1" className={styles.changePasswordInputs} type="password" placeholder="Type your new password" aria-label="New Password" />
          </div>

          <div className={styles.inputLabels}>
            Confirm new password
          </div>
          <div>
            <input onChange={this.handleChange} name="password2" className={styles.changePasswordInputs} type="password" placeholder="Confirm your new password" aria-label="Confirm New Password" />
          </div>

          <div className={styles.centerButtons}>
            <button onClick={this.changePassword} className={classNames(styles.changePasswordConfirmButton, styles.blueButton1)}>
              Submit
            </button>
          </div>

          <div className={styles.centerButtons}>
            <button onClick={this.props.toggleChangePassword} className={classNames(styles.cancelChangePasswordButton, styles.grayButton1)}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userSettings: state.userSettings,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    userSettingsActions: bindActionCreators(userSettingsActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/users/components/UserSettings/ChangePassword.js